export enum ExtentAddressed {
  NotAtAll = 0,
  Somewhat = 1,
  Partially = 2,
  Completely = 3,
}
